import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "..";
import { TextField, AccessErrorModal } from "../../primary";
import styles from "../../../styles/common.module.scss";
import searchIcon from "../../../static/images/search-icon.svg";
import style from "./listView.module.scss";
import { Pagination as assignedPagination } from "../../../utils";
import { setAdminView } from "../../../app/patientSlice";
import { LIST_VIEW_LIMIT } from "../../../constants";
import { getCallBackAssignedFormularyListAsync } from "../../../app/customerSlice";
import DataTableV2 from "../DataTable/DataTableV2";

export const CustListView = ({
  columns,
  data,
  metaData,
  getSelectedRowData,
  searchPlaceholder,
  getSearchValue,
  listSorting,
  uploadingCheckAsync,
  searchKey,
  formularyView,
  getSelectedItems,
  noPage,
  offset,
  accessError,
  facilityNumberOption,
  customerNumberId,
  isLoading,
}) => {
  /* Get url of the current page */
  const path = window.location.href;
  /* Below will return only domain - http://www.google.com */
  const origin = window.location.origin;

  const dispatch = useDispatch();

  const [sortBy, setSortBy] = useState({ column: null, direction: null });

  const [modalShow, setmodalShow] = useState(false);
  const [menuShow, setMenuShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const dropRef = useRef();

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  const handleClickOutside = (e) => {
    if (dropRef !== null && dropRef.current && !dropRef.current.contains(e.target)) {
      setMenuShow(false);
    }
  };

  const getFacilities = useSelector((state) => state.patient.newFacilitiesData);

  useEffect(() => {
    let fac = "";
    if (
      getFacilities?.errorMessage ||
      (getFacilities?.length === 0 && document.getElementById("customerNumberId") && document.getElementById("customerNumberId").value)
    ) {
      fac = "We didn’t recognize this customer number. Enter a different customer number";
    }
    setErrorMsg(fac);
  }, [getFacilities, facilityNumberOption]);

  const onRowSelect = (rows) => {
    if (formularyView) {
      getSelectedItems(rows);
    }
  };

  //added pagination for
  const urlId = customerNumberId;
  const USERINFORENQ = "/customer" + "/" + urlId + "/users";

  // pagination
  const [activePage, setActivePage] = useState(1);
  const [offSet, setOffSet] = useState(0);
  const [sortType, setSortType] = useState("");
  const getActivePage = (data) => {
    setOffSet(data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT < LIST_VIEW_LIMIT ? 0 : data * LIST_VIEW_LIMIT - LIST_VIEW_LIMIT);
    assignedPagination(data, setActivePage, USERINFORENQ, "Get", LIST_VIEW_LIMIT, dispatch, getCallBackAssignedFormularyListAsync, "", "", sortType);
  };

  const handleSort = useCallback(
    (data) => {
      if (listSorting) {
        let sortingColumn = data.sortBy[0];
        let sortingType = sortingColumn ? (sortingColumn.desc ? ":DESC" : ":ASC") : "";
        listSorting["queryParam"]["sort"] = sortingColumn && sortingColumn.id + sortingType;
        // The below if condition is for 'Sorting' + 'Pagination'
        if (listSorting.setSortType) {
          //dispatch(listSorting.setSortType(listSorting['queryParam']['sort']))
          if (listSorting["queryParam"]["sort"] == undefined && sortType) {
            listSorting["queryParam"]["sort"] = sortType;
          } else {
            if (listSorting["queryParam"]["sort"] && listSorting["queryParam"]["sort"] !== undefined) {
              listSorting.setSortType(listSorting["queryParam"]["sort"]);
            }
          }
        }
        dispatch(listSorting.asyncMethod(listSorting));
      }
    },
    [dispatch, searchKey, activePage, offset, sortType]
  );

  const onSort = (column, direction) => {
    if (!column || !direction) return;
    setSortBy({ column, direction });
    const sortType = { sortBy: [{ id: column, desc: direction === "desc" }] };
    handleSort(sortType);
  };

  return (
    <>
      <div className={`col pt-0 pr-0 pb-3`}>
        <div className={`row ${style.ipadm_l}`}>
          {!formularyView && (
            <>
              <br />
              <TextField
                classes={{
                  column: `form-group no-gutters ${styles.form_group} position-relative col-sm-7 p-0`,
                  inputClassName: `form-control mb-1 ${style.pl40}`,
                  labelClass: `position-absolute ${style.search_icon_image}`,
                }}
                label={<img src={searchIcon} alt="search icon" />}
                type={"text"}
                name={"search"}
                id={"search"}
                placeholder={searchPlaceholder}
                title={"Toggle All Rows Selected"}
                onKeyUp={getSearchValue}
                defaultValue={searchKey}
              />
            </>
          )}
        </div>
      </div>
      <>
        <div className={`${style.loader_parent}`}>
          <DataTableV2
            columns={columns}
            data={data ?? []}
            onRowClick={getSelectedRowData}
            onRowSelect={onRowSelect}
            sortBy={sortBy}
            onSort={onSort}
            loading={isLoading}
            emptyMessage="There are no records in this list"
          />
          {!noPage && Array.isArray(data) && data.length > 0 && (
            <Pagination
              activePage={activePage}
              itemsCountPerPage={metaData ? metaData.limit : 50}
              totalItemsCount={metaData ? metaData.total : 0}
              getActivePage={getActivePage}
            />
          )}
        </div>
      </>

      {accessError && !modalShow && <AccessErrorModal />}
    </>
  );
};
